import React from 'react';
import { Button, Text } from '../../Atoms';
import { PhotoLoginOrganisme } from '../../Organisms';
import KeycloakService from '../../Services/KeycloakService';
function TemplateFirstLoginStep3(props) {
  return (
    <div className="login-template">
      <div className="login-template-organism">
           <div className="login-container"> 
                           <Text
                           text="Bienvenue sur votre espace assuré !"
                           type="title-42"
                           className="login-welcome-text"
                         />
                         <div className='first-login-divider' />
                         <div>
                           <Text
                             text="Réinitalisation de votre mot de passe"
                             className="login-title-text"
                           />
                           <div
                             style={{
                               display: 'flex',
                               justifyContent: 'left',
                               alignItems: 'left',
                             }}
                           >  
            
            </div>
            <div>
               <Text
                text="Votre mot de passe a bien été enregistré."
                className="text-description-first-login size-16"
              />
              <Text
                text="Vous pouvez désormais vous connecter. "
                className="text-description-first-login pt-0 size-16"
              />
            </div>
            <div className="first-login-small-container">
              <div className="btn-connexion-first-login-container">
                <Button
                  text="Me connecter"
                  className="btn-next-first-login"
                  iconRight={true}
                  icon="FlecheSuivi"
                  boxShadow
                  onClick={() => KeycloakService.doLogin()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PhotoLoginOrganisme />
    </div>
  );
}

export default TemplateFirstLoginStep3;
